module.exports = __webpack_public_path__ + "static/media/BoxPlotQ8_2.a3d4b2d8.svg";